module.exports = __webpack_public_path__ + "static/media/tortoise05.47c24738.png";